import React from 'react'
import AcquireWebComponent from '../framework/MaterialUI';
import WebsiteVisitsContainer from '../../containers/Insights/WebsiteVisits';
import InsightSummaryContainer from '../../containers/Insights/Summary';
import InsightsAudienceFiles from '../../containers/Insights/AudienceFiles';

class InsightIndex extends AcquireWebComponent {
	render(){
		const reportType = this.props.match.params.type;
		const kindOfReport = this.props.match.params.kind;

		const { location, history } = this.props;
		switch(reportType) {
			case "summary":
				return (<InsightSummaryContainer kindOfReport={kindOfReport} history={history} />);
			case "audience":
				return (<InsightsAudienceFiles />);
			default:
				return(
					<WebsiteVisitsContainer location={location} reportType={reportType} kindOfReport={kindOfReport} history={history} />
				)
		}
	}
}

export default InsightIndex



// WEBPACK FOOTER //
// ./src/components/Insights/index.jsx